export default __webpack_public_path__ + "static/media/clue2.b6b10a7b.jpg";